import 'babel-polyfill';
import React from 'react';
import { HashRouter, Redirect, Route, Switch } from 'react-router-dom';
import { createBrowserHistory } from 'history';
import { connect } from 'react-redux';
import Loader from 'react-loader-spinner';

import Header from './Components/Header';
import Register from './pages/Register';
import QtdProduto from './pages/QtdProduto';
import OndeUsar from './pages/OndeUsar';
import OndeReceber from './pages/OndeReceber';
import OndeReceberAdesivo from './pages/OndeReceberAdesivo';
import TipoPagamento from './pages/TipoPagamento';
import ReviseCompra from './pages/ReviseCompra';
import FormaPagamento from './pages/FormaPagamento';
import PedidoConcluido from './pages/PedidoConcluido';

import NoMatch from './pages/NoMatch';
import RecargaAutomatica from './pages/RecargaAutomatica';
import ReturnPedidoConcluido from './pages/ReturnPedidoConcluido';
import DadosVeiculo from './pages/DadosVeiculo';
export const DEFAULT_PATH = '/eu-quero/';

export const APP_PAGES = {
  CADASTRO: '/cadastro',
  RECEBER_PRODUTO: '/receber-produto',
  ONDE_RECEBER_ADESIVO: '/onde-receber-adesivo',
  QTD_PRODUTO: '/quantidade-produto',
  ONDE_USAR: '/onde-usar',
  DADOS_VEICULO: '/dados-veiculo',
  ONDE_RECEBER: '/onde-receber',
  ENDERECO: '/endereco',
  TIPO_PAGAMENTO: '/tipo-pagamento',
  RECARGA_AUTOMATICA: '/recarga-automatica',
  REVISE_COMPRA: '/revise-compra',
  FORMA_PAGAMENTO: '/forma-pagamento',
  PEDIDO_CONCLUIDO: '/pedido-concluido',
  RETURN_PEDIDO_CONCLUIDO: '/return-pedido-concluido',
};

/**
 * Classe responsável por carregar os componentes do fluxo de compras
 *
 * Utiliza Redux para criar e armazenar os estados das variáveis
 * Componentes:
 * 1.  Cadastro
 * 2.  TipoVeiculo
 * 3.  TipoProduto
 * 4.  QtdProduto
 * 5.  OndeUsar
 * 6.  OndeReceber
 * 7.  TipoPagamento
 * 8.  ReviseCompra
 * 9.  PedidoConcluido
 * 10. DadosVeiculo
 * */
const mapStateToProps = ({ pedido }) => {
  return { pedido };
};
const FCGLoader = connect(mapStateToProps)(({ pedido }) => {
  const { loader_active } = pedido;
  return (
    loader_active && (
      <div className="loader">
        <Loader type="Oval" color="#00BFFF" height={80} width={80} />
      </div>
    )
  );
});
export default function Routes() {
  const browserHistory = createBrowserHistory();
  return (
    <HashRouter history={browserHistory}>
      <div className="containerApp">
        <Header />
        <FCGLoader />
        <div className="containerComponentsApp">
          <Switch>
            <Route exact path="/">
              <Redirect to={APP_PAGES.CADASTRO} />
            </Route>
            <Route
              path={APP_PAGES.CADASTRO}
              component={Register}
              history={browserHistory}
            />
            <Route
              path={APP_PAGES.RECEBER_PRODUTO}
              component={OndeReceberAdesivo}
              history={browserHistory}
            />
            <Route
              path={APP_PAGES.QTD_PRODUTO}
              component={QtdProduto}
              history={browserHistory}
            />
            <Route
              path={APP_PAGES.ONDE_USAR}
              component={OndeUsar}
              history={browserHistory}
            />
            <Route
              path={APP_PAGES.ONDE_RECEBER}
              component={OndeReceber}
              history={browserHistory}
            />

            <Route
              path={APP_PAGES.DADOS_VEICULO}
              component={DadosVeiculo}
              history={browserHistory}
            />

            <Route
              path={APP_PAGES.ENDERECO}
              component={OndeReceber}
              history={browserHistory}
            />

            <Route
              path={APP_PAGES.TIPO_PAGAMENTO}
              component={TipoPagamento}
              history={browserHistory}
            />

            <Route
              path={APP_PAGES.RECARGA_AUTOMATICA}
              component={RecargaAutomatica}
              history={browserHistory}
            />
            <Route
              path={APP_PAGES.REVISE_COMPRA}
              component={ReviseCompra}
              history={browserHistory}
            />
            <Route
              path={APP_PAGES.FORMA_PAGAMENTO}
              component={FormaPagamento}
              history={browserHistory}
            />
            <Route
              path={APP_PAGES.PEDIDO_CONCLUIDO}
              component={PedidoConcluido}
              history={browserHistory}
            />
            <Route
              path={APP_PAGES.RETURN_PEDIDO_CONCLUIDO}
              component={ReturnPedidoConcluido}
              history={browserHistory}
            />

            <Route component={NoMatch} />
          </Switch>
        </div>
      </div>
    </HashRouter>
  );
}
